export const getTestList = (payload?: any) => ({
    type: "@saga/GET_TEST_LIST",
    payload
});

